<template>
    <svg width="26" height="30" viewBox="0 0 26 30" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M20.4286 18.75C19.1165 18.75 17.9106 19.2081 16.9586 19.9743L11.0108 16.2212C11.1869 15.4167 11.1869 14.5832 11.0108 13.7788L16.9586 10.0256C17.9106 10.7919 19.1165 11.25 20.4286 11.25C23.5056 11.25 26 8.73158 26 5.625C26 2.51842 23.5056 0 20.4286 0C17.3516 0 14.8571 2.51842 14.8571 5.625C14.8571 6.04441 14.903 6.45293 14.9892 6.84615L9.04138 10.5993C8.08942 9.83314 6.8835 9.375 5.57143 9.375C2.49443 9.375 0 11.8934 0 15C0 18.1066 2.49443 20.625 5.57143 20.625C6.8835 20.625 8.08942 20.1669 9.04138 19.4007L14.9892 23.1538C14.9013 23.5548 14.857 23.9643 14.8571 24.375C14.8571 27.4816 17.3516 30 20.4286 30C23.5056 30 26 27.4816 26 24.375C26 21.2684 23.5056 18.75 20.4286 18.75Z" fill="currentColor"/>
    </svg>
</template>

<script>
export default {
    name: "SVGShare"
}
</script>

<style scoped>

</style>
